import { ComponentBodyAffiliateProgramGroup, Maybe } from '@/gql/generated/graphql'
import React from 'react'
import RichText from '../renderer/RichText'
import AffiliateProgram from '../core/AffiliateProgram'

type Props = {
  data: Maybe<ComponentBodyAffiliateProgramGroup>
}

export default function AffiliateProgramGroup(props: Props) {
  return (
    <section className="affiliate-program-section bg-[#F7F5FE] py-16">
      <div className="container">
        <div className="flex flex-wrap justify-center gap-x-5">
          {props.data?.cards?.map((card, index) => (
            <AffiliateProgram key={index} card={card} />
            ))
          }
        </div>
      </div>
    </section>
  )
}
